import { createContext } from 'react';

import type { ViewParametersContextValue } from './viewParametersContextTypes';

export const ViewParametersContext = createContext<
  ViewParametersContextValue | undefined
>(undefined);
